export default class ChatError extends Error {
  message: string
  repeat?: () => void
  report?: boolean
  payload?: unknown

  constructor(message: string, options?: { repeat?: () => void; report?: boolean; payload?: unknown }) {
    super(message)
    this.message = message
    this.name = 'ChatError'
    this.repeat = options?.repeat
    this.report = options?.report
    this.payload = options?.payload
  }
}
